import { apiCall } from './gqlClient';
const GETSERVICESBYRESOURCE_QUERY = "\n  query getServicesByResource($resourceId: Int!) {\n    getServicesByResource(resourceId: $resourceId)\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getServicesByResourceApiCall = async function (_ref) {
  let {
    resourceId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSERVICESBYRESOURCE_QUERY,
    variables: {
      resourceId
    },
    fragments
  });
};
const GETOFFERSBYRESOURCE_QUERY = "\n  query getOffersByResource($resourceId: Int!) {\n    getOffersByResource(resourceId: $resourceId)\n    {\n      id\n\t\t\tproviderId\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tminimumCapacity\n\t\t\tprice\n\t\t\tmodel\n\t\t\tsessionLimit\n\t\t\tactive\n\t\t\torderIndex\n\t\t\tsessionsCounter\n\t\t\tentityType\n\t\t\tlocationType\n\t\t\tcustomerId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getOffersByResourceApiCall = async function (_ref2) {
  let {
    resourceId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETOFFERSBYRESOURCE_QUERY,
    variables: {
      resourceId
    },
    fragments
  });
};
const GETSERVICES_QUERY = "\n  query getServices($type: String) {\n    getServices(type: $type)\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getServicesApiCall = async function (_ref3) {
  let {
    type
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSERVICES_QUERY,
    variables: {
      type
    },
    fragments
  });
};
const GETSERVICESCOURSESEVENTS_QUERY = "\n  query getServicesCoursesEvents {\n    getServicesCoursesEvents\n    {\n      id\n\t\t\tname\n\t\t\ttype\n\t\t\tpricing\n      ...fragments\n    }\n  }";
export const getServicesCoursesEventsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETSERVICESCOURSESEVENTS_QUERY,
    variables: {},
    fragments
  });
};
const GETSIMPLFIEDSERVICESSUBSERVICESCLASSES_QUERY = "\n  query getSimplfiedServicesSubServicesClasses {\n    getSimplfiedServicesSubServicesClasses\n  }";
export const getSimplfiedServicesSubServicesClassesApiCall = async () => apiCall({
  query: GETSIMPLFIEDSERVICESSUBSERVICESCLASSES_QUERY,
  variables: {}
});
const GETARCHIVEDSERVICES_QUERY = "\n  query getArchivedServices($type: String) {\n    getArchivedServices(type: $type)\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getArchivedServicesApiCall = async function (_ref4) {
  let {
    type
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETARCHIVEDSERVICES_QUERY,
    variables: {
      type
    },
    fragments
  });
};
const GETPROVIDERALLSERVICES_QUERY = "\n  query getProviderAllServices($type: String) {\n    getProviderAllServices(type: $type)\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getProviderAllServicesApiCall = async function (_ref5) {
  let {
    type
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPROVIDERALLSERVICES_QUERY,
    variables: {
      type
    },
    fragments
  });
};
const GETPUBLICSERVICES_QUERY = "\n  query getPublicServices($providerId: Int) {\n    getPublicServices(providerId: $providerId)\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getPublicServicesApiCall = async function (_ref6) {
  let {
    providerId
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPUBLICSERVICES_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const GETPUBLICCOURSES_QUERY = "\n  query getPublicCourses($providerId: Int) {\n    getPublicCourses(providerId: $providerId)\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getPublicCoursesApiCall = async function (_ref7) {
  let {
    providerId
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPUBLICCOURSES_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const GETPUBLICEVENTS_QUERY = "\n  query getPublicEvents($providerId: Int) {\n    getPublicEvents(providerId: $providerId)\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getPublicEventsApiCall = async function (_ref8) {
  let {
    providerId
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPUBLICEVENTS_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const GETALLSERVICES_QUERY = "\n  query getAllServices($providerId: Int) {\n    getAllServices(providerId: $providerId)\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getAllServicesApiCall = async function (_ref9) {
  let {
    providerId
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETALLSERVICES_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const GETALLCOURSES_QUERY = "\n  query getAllCourses($providerId: Int) {\n    getAllCourses(providerId: $providerId)\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getAllCoursesApiCall = async function (_ref0) {
  let {
    providerId
  } = _ref0;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETALLCOURSES_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const GETALLEVENTS_QUERY = "\n  query getAllEvents($providerId: Int) {\n    getAllEvents(providerId: $providerId)\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getAllEventsApiCall = async function (_ref1) {
  let {
    providerId
  } = _ref1;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETALLEVENTS_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const GETCOURSESANDEVENTS_QUERY = "\n  query getCoursesAndEvents {\n    getCoursesAndEvents\n    {\n      id\n\t\t\tsvcTypeId\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tduration\n\t\t\tresolution\n\t\t\ttimeUnit\n\t\t\tcapacity\n\t\t\tprice\n\t\t\tcancel\n\t\t\trecurring\n\t\t\tactive\n\t\t\tarchive\n\t\t\torderIndex\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tpricing\n\t\t\ttarget\n\t\t\tsessionLimit\n\t\t\ttype\n\t\t\tuserHasMembership\n\t\t\tclassesCounter\n\t\t\tsubServicesCounter\n\t\t\tisAlwaysAvailable\n\t\t\tdefaultTimeSlotStep\n\t\t\tactiveClasses\n\t\t\tthumbnailUrl\n\t\t\timageId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getCoursesAndEventsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETCOURSESANDEVENTS_QUERY,
    variables: {},
    fragments
  });
};
const TOGGLESERVICESTATUS_QUERY = "\n  mutation toggleServiceStatus($id: Int!, $status: Boolean!, $type: String!) {\n    toggleServiceStatus(id: $id, status: $status, type: $type)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const toggleServiceStatusApiCall = async function (_ref10) {
  let {
    id,
    status,
    type
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLESERVICESTATUS_QUERY,
    variables: {
      id,
      status,
      type
    },
    fragments
  });
};
const PUBLISHALLSERVICECHILDREN_QUERY = "\n  mutation publishAllServiceChildren($id: Int!, $type: String!) {\n    publishAllServiceChildren(id: $id, type: $type)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const publishAllServiceChildrenApiCall = async function (_ref11) {
  let {
    id,
    type
  } = _ref11;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: PUBLISHALLSERVICECHILDREN_QUERY,
    variables: {
      id,
      type
    },
    fragments
  });
};
const REORDERSERVICES_QUERY = "\n  mutation reorderServices($type: String!, $oldPosition: Int!, $newPosition: Int!) {\n    reorderServices(type: $type, oldPosition: $oldPosition, newPosition: $newPosition)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const reorderServicesApiCall = async function (_ref12) {
  let {
    type,
    oldPosition,
    newPosition
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REORDERSERVICES_QUERY,
    variables: {
      type,
      oldPosition,
      newPosition
    },
    fragments
  });
};
const SAVESERVICE_QUERY = "\n  mutation saveService($request: ServiceCreateInput!) {\n    saveService(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveServiceApiCall = async function (_ref13) {
  let {
    request
  } = _ref13;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVESERVICE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const ARCHIVESERVICE_QUERY = "\n  mutation archiveService($id: Int!) {\n    archiveService(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const archiveServiceApiCall = async function (_ref14) {
  let {
    id
  } = _ref14;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ARCHIVESERVICE_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const RESTORESERVICE_QUERY = "\n  mutation restoreService($id: Int!) {\n    restoreService(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const restoreServiceApiCall = async function (_ref15) {
  let {
    id
  } = _ref15;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: RESTORESERVICE_QUERY,
    variables: {
      id
    },
    fragments
  });
};